/**
 * PostHog SDK URL properties that may contain PII in query strings or hashes.
 * Stripped to origin + pathname before events leave the browser.
 */
export const POSTHOG_URL_PROPERTIES = new Set([
	"$current_url",
	"$referrer",
	"$pathname",
	"$session_entry_url",
]);

/**
 * Removes search params and hash from a URL string to prevent PII leakage.
 *
 * For absolute URLs (with protocol), returns the full URL with origin + pathname only.
 * For relative URLs (no protocol), returns just the pathname portion.
 * Falls back to string manipulation if URL parsing fails.
 *
 * @param {string} url - The URL string to sanitize (absolute or relative)
 * @returns {string} The sanitized URL without search params or hash
 */
export function stripUrlSearchAndHash(url: string): string {
	try {
		const hasProtocol = /^[a-z][a-z0-9+.-]*:/i.test(url);
		const parsed = hasProtocol
			? new URL(url)
			: new URL(url, "https://placeholder.invalid");

		parsed.search = "";
		parsed.hash = "";

		if (!hasProtocol) {
			return parsed.pathname;
		}

		return parsed.href;
	} catch {
		const withoutHash = url.split("#")[0];
		const queryIndex = withoutHash.indexOf("?");

		return queryIndex === -1 ? withoutHash : withoutHash.slice(0, queryIndex);
	}
}
